export type OrderSaleUnit = 'pcs' | 'm2' | 'm3';

export interface OrderSaleQuantityInput {
  quantity?: number | string | null;
  unit?: string | null;
  saleUnit?: string | null;
  saleQuantity?: number | string | null;
}

export const SALE_UNITS: readonly OrderSaleUnit[] = ['pcs', 'm2', 'm3'] as const;

export const getOrderSaleUnit = (product: OrderSaleQuantityInput | undefined): OrderSaleUnit => {
  const value = String(product?.saleUnit || product?.unit || 'pcs').trim().toLowerCase();
  return value === 'm2' || value === 'm3' ? value : 'pcs';
};

const roundSaleQuantity = (value: number) => Number(value.toFixed(3));

// Preview-only mirror of backend orderProductValidation.js. Customer-order
// revenue uses the operator-entered quantity in the selected sale unit; product
// dimensions are logistics metadata, not a multiplier for sale value.
export const calculateSaleQuantity = (product: OrderSaleQuantityInput | undefined) => {
  const quantity = Number(product?.quantity ?? 0);
  if (!Number.isFinite(quantity) || quantity <= 0) return null;
  return roundSaleQuantity(quantity);
};

export const getPreviewSaleQuantity = (product: OrderSaleQuantityInput | undefined) => {
  const calculatedSaleQuantity = calculateSaleQuantity(product);
  if (calculatedSaleQuantity !== null) {
    return calculatedSaleQuantity;
  }

  const pieces = Number(product?.quantity ?? 0);
  return Number.isFinite(pieces) ? pieces : 0;
};
